import type { ButtonGroupItemData } from './types';

export const ButtonGroupItem = ({ children }: ButtonGroupItemData) => {
  return <>{children}</>;
};
